import React from 'react';
import { toast } from 'sonner';

import QuickBook from '../assets/icons/QB.svg';

export const QUICKBOOKS_ONLINE_ERROR_SOURCE = 'quickbooks_online';
export const QUICKBOOKS_ONLINE_ERROR_TITLE = 'QuickBooks Online error';
export const QUICKBOOKS_ONLINE_ERROR_TOAST_ID = 'quickbooks-online-error';

export const isQuickBooksOnlineError = (payload: any): boolean =>
  payload?.isQboError === true ||
  payload?.quickBooksError === true ||
  payload?.errorSource === QUICKBOOKS_ONLINE_ERROR_SOURCE ||
  payload?.source === QUICKBOOKS_ONLINE_ERROR_SOURCE;

export const getQuickBooksOnlineNotificationSource = (payload: any) =>
  isQuickBooksOnlineError(payload) ? QUICKBOOKS_ONLINE_ERROR_SOURCE : undefined;

export const getQuickBooksOnlineErrorTitle = (payload: any) =>
  isQuickBooksOnlineError(payload)
    ? payload?.errorTitle || QUICKBOOKS_ONLINE_ERROR_TITLE
    : undefined;

export const isQuickBooksBundleSetupRequired = (payload: any): boolean => {
  const message = String(payload?.message || payload?.description || '').toLowerCase();
  return (
    payload?.code === 'QBO_BUNDLE_SETUP_REQUIRED' ||
    (message.includes('quickbooks bundle item is missing') &&
      message.includes('export without bundling'))
  );
};

export const showQuickBooksOnlineErrorToast = ({
  message,
  onRetry,
  onBundleSetupRequired,
}: {
  message?: string;
  onRetry?: () => void;
  onBundleSetupRequired?: () => void;
}) => {
  if (isQuickBooksBundleSetupRequired({ message })) {
    if (onBundleSetupRequired) {
      onBundleSetupRequired();
    }
    return;
  }

  toast.error(QUICKBOOKS_ONLINE_ERROR_TITLE, {
    id: QUICKBOOKS_ONLINE_ERROR_TOAST_ID,
    description: message || 'Failed to export estimate to QuickBooks.',
    duration: Infinity,
    icon: <QuickBook width={18} height={18} />,
    action: onRetry
      ? {
          label: 'Retry',
          onClick: onRetry,
        }
      : undefined,
  });
};
